/**
 * @module app.kya.jds.kyaJdsCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function KyaJdsCtrl($scope, $window, $rootScope, $location, contractService, userService) {
        var self = {};

        self.rds = $rootScope.user;
        self.drv = $rootScope.parent;

        self.goToList = function() {
            return $location.path('kya/list/');
        };

        self.contractsJds = $rootScope.contractsJds;
        self.isUpsJds = $rootScope.isUpsJds;

        if (!self.contractsJds) {
            self.goToList();
        }

        /**
         * Get Initiator to display
         * @param  {String} initiateBy
         * @return {String}
         */
        self.getInitiator = function(initiateBy) {
            let initiator = userService.findPerson(initiateBy);
            if (initiator) {
                return initiator.user.firstname + ' ' + initiator.user.lastname;
            }
            if ($rootScope.user.uid === initiateBy) {
                return $rootScope.user.firstname + ' ' + $rootScope.user.lastname;
            }
            return initiateBy;
        };

        /**
         * Display manager name
         * @param  {String} managerUid
         * @return {String}
         */
        self.getManager = function(managerUid) {
            let manager = userService.findPerson(managerUid);
            if (manager) {
                return manager.user.firstname + ' ' + manager.user.lastname;
            }
            if ($rootScope.user.parent.uid === managerUid) {
                return $rootScope.user.parent.firstname + ' ' + $rootScope.user.parent.lastname;
            }
            return managerUid;
        };

        /**
         * Display complet name
         * @param  {String} uid
         * @return {String}
         */
        self.getName = function(uid) {
            let people = userService.findPerson(uid);
            if (people) {
                return people.user.firstname + ' ' + people.user.lastname;
            }
            if ($rootScope.user.uid === uid) {
                return $rootScope.user.firstname + ' ' + $rootScope.user.lastname;
            }
            return uid;
        };

        /**
         * Get date fr signature
         * @param  {String} date : YYYY-MM-DD
         * @return {String}
         */
        self.getDateSignature = function(date) {
            return date ? moment(date).format('DD/MM/YYYY') : date;
        };

        /**
         * Get date fr signature
         * @param  {String} date : YYYY-MM-DD
         * @return {String}
         */
        self.getMonthNumberDateSignature = function(date) {
            return date ? moment(date).format('M') : date;
        };

        self.getDate = function(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        };

        self.getStatus = function(contract) {
            // <span className="label label-warning" ng-show="!contract.isSend ">Non envoyé</span>
            // <span className="label label-info" ng-show="contract.isSend ">Envoyé le {{
            // contract
            // .dateSend | date : 'dd/MM/yyyy'}}</span>
            // <span className="label label-success" ng-show="contract.isSigned && !contract.isCancelled">Signé le {{
            // contract
            // .dateSignature | date : 'dd/MM/yyyy'}}</span>
            // <span className="label label-warning" ng-show="!contract.isSigned && contract.isSend && !contract.isCancelled">Non Signé</span>
            // <span className="label label-danger" ng-show="contract.isCancelled">Annulé le {{
            // contract
            // .dateCancellation | date : 'dd/MM/yyyy'}}</span>
            // <span className="label label-info" ng-show="contract.isJdsInjected">Injecté dans le JDS</span>
            if (!contract.isSend && !contract.isCancelled) {
                return 'Non envoyé';
            }
            if (contract.isSend && !contract.isSigned && !contract.isCancelled) {
                return 'Envoyé';
            }
            if (contract.isSigned && !contract.isCancelled) {
                return 'Signé';
            }
            if (contract.isCancelled && contract.contractId === null) {
                return 'Annulé';
            }
            if (contract.isCancelled && contract.contractId !== null) {
                return 'Annulé / Remplacé';
            }
        };

        self.getDepartment = function(postalCode) {
            return postalCode.substr(0, 2);
        };

        self.getIsScanup = function(contrat) {
            return contrat.isUpsAccessScanup === '1'
                ? "Scan'up"
                : contrat.isUpsAccessScanup === '0'
                    ? 'Téléphone'
                    : "Scan'up et Téléphone";
        };

        self.getModel = function(contract) {
            if ((contract.isUpsAccessScanup === '1' || contract.isUpsAccessScanup === '2') && contract.typeScanup) {
                return contract.typeScanup === 'mitac'
                    ? "Scan'up Mitac"
                    : contract.typeScanup === 'evolution'
                        ? "Scan'up Evolution"
                        : contract.typeScanup === 'all-in-one'
                            ? "Scan'up All-in-One"
                            : '';
            }
            return "Pas de Scan'up";
        };

        self.getCivility = function(civility) {
            return civility === 'Monsieur' ? 'Mr' : 'Mrs';
        };

        self.transformPhone = function(phoneNumber) {
            const regex = /^0/i;
            return phoneNumber !== null ? phoneNumber.replace(regex, '0033') : '';
        };

        self.transformLocation = function(location) {
            return location !== null ? location.substr(0, 7) : '';
        };

        function _initHours(hours) {
            for (let i = 0; i < hours.length; i++) {
                if (
                    (hours[i].morningClose === null || hours[i].morningClose.trim() === '') &&
                    hours[i].afternoonClose !== null
                ) {
                    hours[i].morningClose = hours[i].afternoonClose;
                    hours[i].afternoonClose = null;
                }
                hours[i].morningOpen = hours[i].morningOpen !== null ? moment(hours[i].morningOpen, 'HH:mm:ss').format('HH:mm') : '';
                hours[i].morningClose = hours[i].morningClose !== null ? moment(hours[i].morningClose, 'HH:mm:ss').format('HH:mm') : '';
                hours[i].afternoonOpen =
                    hours[i].afternoonOpen !== null ? moment(hours[i].afternoonOpen, 'HH:mm:ss').format('HH:mm') : '';
                hours[i].afternoonClose =
                    hours[i].afternoonClose !== null ? moment(hours[i].afternoonClose, 'HH:mm:ss').format('HH:mm') : '';
            }
        }

        self.contractsJds.map(contract => _initHours(contract.horaires));

        return self;
    }

    KyaJdsCtrl.$inject = ['$scope', '$window', '$rootScope', '$location', 'contractService', 'userService'];

    angular.module('app.kya.jds.kyaJdsCtrl', []).controller('KyaJdsCtrl', KyaJdsCtrl);
});
